module.exports = __webpack_public_path__ + "img/generating_reports.4f3e64fa.svg";